import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators, ControlContainer, FormGroupDirective } from '@angular/forms';
import * as moment from 'moment';
import { SearchField } from './search-filter.model';


@Component({
    selector: 'app-search-filter',
    templateUrl: './search-filter.component.html',
    styleUrls: ['./search-filter.component.scss'],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective }
    ],
    exportAs: 'appSearchFilter'
})
export class SearchFilterComponent implements OnInit {

    @Input()
    public startDateMax: Date = moment().add(2, 'days').toDate();

    @Input()
    public startDateMin: Date = moment().subtract(60, 'days').toDate();

    @Input()
    public filter: SearchField;

    searchFilterForm: FormGroup;

    startDate: Date;
    time: Date;
    duration: number;

    @Output()
    public selectFilter = new EventEmitter<SearchField>();

    @Output()
    public clearFilter = new EventEmitter<any>();


    constructor(private parent: FormGroupDirective) { }

    ngOnInit() {
        this.searchFilterForm = this.parent.form;

        const startDate = new FormControl('', Validators.required);
        const time = new FormControl('', Validators.required);
        const duration = new FormControl('', Validators.required);

        const appSearchFilter = new FormGroup({ startDate, time, duration });

        this.searchFilterForm.addControl('searchFilter', appSearchFilter);

        if (this.filter) {
            this.startDate = this.filter.startDate;
            this.time = this.filter.startDate;
            this.duration = this.filter.duration;
        }
    }

    public clear(): void {
        this.startDate = null;
        this.duration = null;
        this.time = null;
        this.filter.startDate = null;
        this.filter.duration = null;
        this.clearFilter.emit(null);
    }

    isValidForm(): boolean {
        return this.searchFilterForm.valid;
    }
    public apply(): void {
        if (this.isValidForm()) {
            const startDateTimeString = `${moment(this.startDate).format('YYYY-MM-DD')} ${moment(this.time).format('HH:mm:ss')}`;
            const startDateTime = moment(startDateTimeString, 'YYYY-MM-DD HH:mm:ss');

            this.selectFilter.emit(new SearchField(startDateTime.toDate(), this.duration));
        }
    }

}
